import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SpaceMapAssignSpaceComponent } from "./space-map-assign-space.component";
import { ModalHeaderComponentModule } from "../../../modal-header/modal-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SearchBarModule } from "../../../search-bar/search-bar.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    ModalHeaderComponentModule,
    TranslateModule,
    HeaderModule,
    SearchBarModule,
  ],
  declarations: [SpaceMapAssignSpaceComponent],
  exports: [SpaceMapAssignSpaceComponent],
})
export class SpaceMapAssignSpaceComponentModule {}
